import { render, staticRenderFns } from "./ChatFansInfo.vue?vue&type=template&id=779a1cc4&"
import script from "./ChatFansInfo.vue?vue&type=script&lang=js&"
export * from "./ChatFansInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatFansInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports